import { coerceNumberProperty } from "@angular/cdk/coercion";

export function coerceNumber() {
	return (target: any, key: string) => {
		Object.defineProperty(target, key, {
			get() {
				return this[`_coerceNumber_${key}`];
			},
			set(value) {
				this[`_coerceNumber_${key}`] = coerceNumberProperty(value);
			},
		});
	};
}
